import { getNameOfElementTyp } from "actions/getNameOfOprawa";
import { TechnologyContext } from "context/TechnologyContext";
import React, { useContext, useState } from "react";
import { _typ_elementu } from "utils/initialvalue";

const DOZWOLONE_WARTOSCI = [2, 4, 8, 12, 16, 24, 32];

export default function ElementyTechManager() {
  const { elementyTech, setElementyTech } = useContext(TechnologyContext);
  const [draggingItem, setDraggingItem] = useState(null);
  
  // Stan do śledzenia, nad którym kafelkiem jest myszka (przechowuje id elementu i indeks)
  const [hoveredTile, setHoveredTile] = useState(null);

  const handleZmienWartosc = (elemId, indexLiczby, nowaWartosc) => {
    const val = Number(nowaWartosc);
    if (!DOZWOLONE_WARTOSCI.includes(val)) return;

    setElementyTech((prev) =>
      prev.map((el) => {
        if (el.id !== elemId) return el;
        const currentLeg = el.kolejnoscLeg || [];
        const nowaKolejnosc = [...currentLeg];
        nowaKolejnosc[indexLiczby] = val;
        return { ...el, kolejnoscLeg: nowaKolejnosc };
      })
    );
  };

  const handleDodajLiczbe = (elemId) => {
    setElementyTech((prev) =>
      prev.map((el) => {
        if (el.id !== elemId) return el;
        const currentLeg = el.kolejnoscLeg || [];
        return { ...el, kolejnoscLeg: [...currentLeg, el.typ!=2 ? 4:16] };
      })
    );
  };

  const handleUsunLiczbe = (elemId, indexLiczby) => {
    setElementyTech((prev) =>
      prev.map((el) => {
        if (el.id !== elemId) return el;
        const currentLeg = el.kolejnoscLeg || [];
        const nowaKolejnosc = currentLeg.filter((_, idx) => idx !== indexLiczby);
        return { ...el, kolejnoscLeg: nowaKolejnosc };
      })
    );
  };

  const handleDragStart = (elemId, index) => {
    setDraggingItem({ elemId, index });
  };

  const handleDrop = (targetElemId, targetIndex) => {
    if (!draggingItem) return;
    if (draggingItem.elemId !== targetElemId) return;

    setElementyTech((prev) =>
      prev.map((el) => {
        if (el.id !== targetElemId) return el;

        const currentLeg = el.kolejnoscLeg || [];
        const nowaKolejnosc = [...currentLeg];
        const [przenoszonaWartosc] = nowaKolejnosc.splice(draggingItem.index, 1);
        nowaKolejnosc.splice(targetIndex, 0, przenoszonaWartosc);

        return { ...el, kolejnoscLeg: nowaKolejnosc };
      })
    );

    setDraggingItem(null);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  return (
    <div style={{ width: "100%", boxSizing: "border-box", padding: "16px", fontFamily: "system-ui, -apple-system, sans-serif" }}>
      {elementyTech?.map((elem) => {
        const kolejnosc = elem.kolejnoscLeg || [];

        return (
          <div
            key={elem.id}
            style={{
              background: "#ffffff",
              border: "1px solid #e2e8f0",
              borderRadius: "8px",
              padding: "10px",
              marginBottom: "10px",
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
              boxSizing: "border-box",
              width: "100%",
              // height:"100px"
            }}
            // onMouseOver={(e) => (e.currentTarget.style.background = "#f1f1f1")}
            //     onMouseOut={(e) => (e.currentTarget.style.background = "#ffffff")}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
              <h4 style={{ margin: 0, fontSize: "16px", color: "#56657d", fontWeight: "600" }}>
                {`Kolejność leg -  ${getNameOfElementTyp( parseInt( elem.typ),_typ_elementu)} ${elem.nazwa} ${elem.uwagi}` }
              </h4>
              <span style={{ fontSize: "12px", color: "#64748b", background: "#f1f5f9", padding: "2px 8px", borderRadius: "12px" }}>
                ID: {elem.id}
              </span>
                            {/* <button
                            title="Dodaj lege"
                type="button"
                onClick={() => handleDodajLiczbe(elem.id)}
                style={{
                  padding: "2px 6px",
                  background: "rgb(114, 212, 49,0.8)",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontWeight: "600",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                  transition: "background 0.2s",
                }}
                onMouseOver={(e) => (e.currentTarget.style.background = "#0369a1")}
                onMouseOut={(e) => (e.currentTarget.style.background = "#0284c7")}
              > +</button> */}
            </div>
            
            {/* <p style={{ fontSize: "13px", color: "#64748b", marginBottom: "14px", marginTop: 0 }}>
              Przeciągaj kafelki myszką, aby zmienić ich kolejność.
            </p> */}

            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", alignItems: "center" }}>
              {kolejnosc.length === 0 ? (
                <div style={{ color: "#94a3b8", fontStyle: "italic", fontSize: "14px", padding: "8px 0" }}>
                  {/* Brak elementów w sekcji. Kliknij przycisk poniżej, aby dodać pierwszą wartość. */}
                </div>
              ) : (
                kolejnosc.map((liczba, index) => {
                  // Sprawdzamy, czy ten konkretny kafelek jest aktualnie najechany myszką
                  const isHovered = hoveredTile?.elemId === elem.id && hoveredTile?.index === index;

                  return (
                    <div
                      key={index}
                      draggable
                      onDragStart={() => handleDragStart(elem.id, index)}
                      onDragOver={handleDragOver}
                      onDrop={() => handleDrop(elem.id, index)}
                      onMouseEnter={() => setHoveredTile({ elemId: elem.id, index })}
                      onMouseLeave={() => setHoveredTile(null)}
                      style={{
                        position: "relative",
                        background: "#f8fafc",
                        border: "1px solid #cbd5e1",
                        borderRadius: "6px",
                        padding: "5px 5px 5px 12px",
                        cursor: "grab",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "6px",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.02)",
                        transition: "border-color 0.2s, box-shadow 0.2s",
                        width:"140px"
                      }}
                    >
                      {/* Przycisk usuwania renderuje się tylko wtedy, gdy myszka jest na tym kafelku */}
                      {isHovered && (
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleUsunLiczbe(elem.id, index);
                          }}
                          title="Usuń tę wartość"
                          style={{
                            position: "absolute",
                            top: "-6px",
                            right: "-6px",
                            background: "#ef4444",
                            color: "#fff",
                            border: "none",
                            borderRadius: "50%",
                            width: "20px",
                            height: "20px",
                            fontSize: "12px",
                            fontWeight: "bold",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: 0,
                            boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                            zIndex: 2,
                          }}
                        >
                          ×
                        </button>
                      )}

                      <span style={{ fontSize: "14px", color: "#94a3b8", fontWeight: "500", textTransform: "uppercase" }}>
                        lega {index + 1}
                      </span>
                      
                      <select
                        value={liczba}
                        onChange={(e) => handleZmienWartosc(elem.id, index, e.target.value)}
                        style={{
                          cursor: "pointer",
                          fontWeight: "600",
                          fontSize: "12px",
                          padding: "2px 5px",
                          borderRadius: "4px",
                          border: "1px solid #cbd5e1",
                          background: "rgb(255, 255, 255,0.3)",
                          color: "#8797bd",
                          outline: "none",
                        }}
                      >
                        {DOZWOLONE_WARTOSCI.map((val) => (
                          <option key={val} value={val}>
                            {val}
                          </option>
                        ))}
                      </select>
                    </div>
                  );
                })
              )}

              <button
                type="button"
                onClick={() => handleDodajLiczbe(elem.id)}
                style={{
                  padding: "2px 8px",
                  background: "#2c9244",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontWeight: "600",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                  transition: "background 0.2s",
                }}
                // onMouseOver={(e) => (e.currentTarget.style.background = "#0369a1")}
                // onMouseOut={(e) => (e.currentTarget.style.background = "#0284c7")}
              >
                + 
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}